











import { Vue, Component, Prop } from 'vue-property-decorator';
import InspectionForm from './inspectionForm.vue';
@Component({
    components: {
        InspectionForm
    }
})
export default class InspectionTemplatePreview extends Vue {
    @Prop() inspectionForm: CommonTypes.mapObject;
}
